export enum Experiment {
  /**
   * This experiment is used to switch out the primary CTA on the product hero
   */
  PRODUCT_HERO_CTA = "product-hero-cta",
}
